// extracted by mini-css-extract-plugin
module.exports = {"main":"ExpectedPriceAndBidNow_main__PzTXb","container":"ExpectedPriceAndBidNow_container__3f1qv","bidNowBtn":"ExpectedPriceAndBidNow_bidNowBtn__PIMDg"};